import axios from "axios";
import { ADMIN_PORTAL_AUTH_TOKEN, ADMIN_PORTAL_API_BASE_URL } from "../utils/config";

export const deleteCacheDocs = async (cacheName, docId, activeTab) => {
    const data = {
        cache_name: cacheName,
        id: docId,
        source: activeTab === "ABCD App" ? "abcd" : "service"
    }
    let config = {
        method: "post",
        url: `${ADMIN_PORTAL_API_BASE_URL}/delete_document_in_cache`,
        data: data,
        headers: {
            Authorization: "Bearer " + ADMIN_PORTAL_AUTH_TOKEN
        }
    };
    try {
        const response = await axios(config);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}